import { graphql, useStaticQuery } from 'gatsby';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';
import { CatalogPageProps } from '../components/Sections/Catalog/CatalogSections';
type FrontMatterProps = {
  title: string;
  date: Date;
  slug: string;
  code: string;
  badge: string;
  published: boolean;
  featured: boolean;
  category: string;
  tags: string[];
  featuredImage: FileNode;
  embeddedImagesLocal: [FileNode];
  description: string;
};

export interface CatalogCardProps {
  id: string;
  frontmatter: FrontMatterProps;
}
interface CatalogProps {
  catalogItems: CatalogCardProps[];
}
const catalogQuery = () => {
  const data = useStaticQuery(graphql`
    query CatalogQuery {
      catalog: allMdx(
        sort: { frontmatter: { date: ASC } }
        filter: {
          frontmatter: { category: { eq: "catalog" }, published: { eq: true } }
        }
        limit: 1000
      ) {
        catalogItems: nodes {
          id
          frontmatter {
            title
            date(formatString: "MMM Do, YYYY")
            code
            slug
            published
            featured
            category
            tags
            description
            badge
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
            embeddedImagesLocal {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
          }
        }
      }
      pageContentJson {
        catalogPage {
          title
          subtitle
          copy
        }
      }
    }
  `);

  const catalog: CatalogProps = data.catalog;
  const content: CatalogPageProps = data.pageContentJson.catalogPage;
  return { catalog, content };
};

export { catalogQuery };
